import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { DownloadFile, ImageFile } from './download-file.model';

@Injectable()
export class DownloadFileGenerator {
  downloadToFile(file: DownloadFile): void {
    const virtualElement: HTMLAnchorElement = this.document.createElement('a');
    const blob: Blob = new Blob([file.content], { type: file.type });
    virtualElement.href = URL.createObjectURL(blob);
    virtualElement.download = file.name;
    virtualElement.click();
    URL.revokeObjectURL(virtualElement.href);
  }

  downloadToImage(file: ImageFile): void {
    const virtualElement: HTMLAnchorElement = this.document.createElement('a');
    const fileName = `${file.name}.${file.format}`;
    const mimeType = `image/${file.format}`;
    virtualElement.download = fileName;
    virtualElement.href = file.canvas.toDataURL(mimeType);
    virtualElement.click();
  }

  constructor(@Inject(DOCUMENT) private document: Document) {}
}
